module.exports = __webpack_public_path__ + "img/showHow4.0d25f2f4.png";